var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-goods-info",
      attrs: {
        title: "售后商品信息",
        visible: _vm.visibleDialog,
        width: "1100px",
        top: "calc(50vh - 220px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "goods-con",
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, height: "300px" } },
            [
              _c("el-table-column", {
                attrs: { label: "商品" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "goods-info" }, [
                          _c(
                            "div",
                            { staticClass: "img" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticClass: "pic",
                                  attrs: {
                                    src: scope.row.goodsSkuPic,
                                    fit: "cover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "con" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(scope.row.goodsName)),
                            ]),
                            _c("div", { staticClass: "text" }, [
                              _vm._v(_vm._s(scope.row.goodsSkuName)),
                            ]),
                            _c("div", { staticClass: "text" }, [
                              _vm._v("体积：" + _vm._s(scope.row.goodsVolume)),
                              _c("span", { staticClass: "space" }),
                              _vm._v("重量：" + _vm._s(scope.row.goodsWeight)),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "编号", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            "商品编号：" + _vm._s(scope.row.goodsSku || "缺失")
                          ),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            "外部编号：" + _vm._s(scope.row.wuyuSku || "缺失")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "售后类型", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.afterSalesTypeName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "售后件登记", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("完好：" + _vm._s(scope.row.intactQuantity)),
                        ]),
                        _c("div", { staticClass: "name" }, [
                          _vm._v("破损：" + _vm._s(scope.row.damagedQuantity)),
                        ]),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            "漏件：" + _vm._s(scope.row.missingPartsQuantity)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "是否理赔", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.isClaim ? "是" : "否")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "快速理赔金额", width: "95" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("￥" + _vm._s(scope.row.claimAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "售后件备注", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.itemRemark)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "售后件阶段", width: "85" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.subsetStatusName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "发起退换时间", width: "94" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.applyTimeDay)),
                        ]),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.applyTimeTime)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }